// extracted by extract-css-chunks-webpack-plugin
module.exports = {"facet":"facet___3mMPm","title":"title___1amq-","titleFontWeight":"titleFontWeight___1LaY8","expander":"expander___if1a6","panel":"panel___2ZuX7"};